var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "brand" },
    [
      _c("tree-transfer", {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loadBrand,
            expression: "loadBrand"
          }
        ],
        attrs: {
          title: _vm.transTitle,
          from_data: _vm.fromData,
          to_data: _vm.toData,
          defaultProps: { label: "name" },
          mode: _vm.mode,
          height: "540px",
          filter: ""
        },
        on: { addBtn: _vm.add, removeBtn: _vm.remove }
      }),
      _vm._v(" "),
      _c(
        "el-button",
        { attrs: { type: "primary" }, on: { click: _vm.saveBrand } },
        [_vm._v("保存")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1150b092", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1150b092","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/basic/brand.vue
// module id = null
// module chunks = 